/** 全局打开 Leo SOC助手（与 App 内 Host 单例 drawer 联动） */
import Vue from 'vue'

export const leoOperatorAssistantBus = new Vue()

let assistantPanelOpen = false

export function isLeoOperatorAssistantOpen () {
  return assistantPanelOpen
}

export function setLeoOperatorAssistantOpen (open) {
  assistantPanelOpen = !!open
  leoOperatorAssistantBus.$emit('assistant-panel-open', assistantPanelOpen)
}

/**
 * @param {{ mode?: 'manual'|'guide'|'chat' }} [opts]
 */
export function openLeoOperatorAssistant (opts) {
  const mode = opts && opts.mode
  if (mode === 'manual' || mode === 'guide' || mode === 'chat') {
    leoOperatorAssistantBus.$emit('open', { mode })
  } else {
    leoOperatorAssistantBus.$emit('open', {})
  }
}

export function openLeoOperatorAssistantChat () {
  openLeoOperatorAssistant({ mode: 'chat' })
}

export function openLeoOperatorAssistantGuide () {
  openLeoOperatorAssistant({ mode: 'guide' })
}

export function closeLeoOperatorAssistant () {
  leoOperatorAssistantBus.$emit('close')
}

/** 顶栏开关与助手抽屉统一；唯一入口＝可拖动 Leo FAB（LeoTrainingOperatorAssistantHost） */
export const LEO_SOC_ASSISTANT_UNIFIED_CHAT = true

/**
 * Hash 模式 router.resolve().href 不含 #（vue-router 3.x），iframe 须补全否则白屏。
 * @param {import('vue-router').default} router
 * @param {object} location
 */
export function resolveHashModeRouteUrl (router, location) {
  if (!router || typeof window === 'undefined') return ''
  const r = router.resolve(location)
  let href = (r && r.href) ? String(r.href) : '/'
  if (href.charAt(0) === '#') {
    return window.location.origin + window.location.pathname + href
  }
  if (href.charAt(0) !== '/') href = '/' + href
  return window.location.origin + window.location.pathname + '#' + href
}

const HIDDEN_ROUTE_NAMES = new Set([
  'login',
  'leoLogin',
  'leoPortal',
  'leoConsole',
  'leoStandaloneChat',
  'leoTrainingDecisionDeskMobile',
  'leoMembershipLogin',
  'leoMembershipRegister',
  '404',
  'privacyAgreement',
  'privacyAgreement1',
  'privacyAgreement2',
  'membershipRegister',
  'membershipLogin',
  'leoDeviceIntegrationPublic',
  'deviceCloudRuntimePublic',
  'xrrossSdkEngineerLab',
  'support-ticket-h5',
  'operation',
  'dataShow'
])

/** 是否在当前路由显示 Leo SOC助手 FAB */
export function routeShowsOperatorAssistant (route) {
  if (!route || !route.path) {
    return false
  }
  const name = String(route.name || '')
  if (HIDDEN_ROUTE_NAMES.has(name)) {
    return false
  }
  const p = String(route.path || '').toLowerCase()
  if (p === '/login' || p.startsWith('/membership/') || p.startsWith('/privacy')) {
    return false
  }
  if (p.startsWith('/leo/chat') || p.startsWith('/leo/login') || p === '/leo-portal') {
    return false
  }
  const inMain = (route.matched || []).some(r => r.name === 'main')
  if (inMain) {
    return true
  }
  if (p.startsWith('/leo-') || p.indexOf('ai-trustee') >= 0 || p.indexOf('portal-ops') >= 0) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/leoOperatorAssistant.js